import { render } from "./SlotMachine.vue?vue&type=template&id=b518a142&scoped=true"
import script from "./SlotMachine.vue?vue&type=script&lang=js"
export * from "./SlotMachine.vue?vue&type=script&lang=js"

import "./SlotMachine.vue?vue&type=style&index=0&id=b518a142&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b518a142"]])

export default __exports__